import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "../components/Navbar";
import PortfolioInfo from "../components/PortfolioInfo";
import Footer from "../components/Footer";
import AboutHeroSection from "../components/AboutHero";
import { Helmet } from "react-helmet-async"; // ✅ Added Helmet import

const Portfolio = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Our Portfolio | VisionBird Technologies</title>
        <meta
          name="description"
          content="Explore the VisionBird Technologies portfolio. Discover our successful projects in web development, graphic design, and innovative digital solutions."
        />
      </Helmet>

      <Navbar />
      <AboutHeroSection
        title="OUR"
        highlight="PORTFOLIO"
        afterHighlight=""
        description={`Our portfolio showcases the innovative digital solutions we’ve crafted for clients worldwide, blending creativity, technology, and strategic design to deliver impactful and results-driven projects.`}
        image="/assets/Images/Mobile encryption-bro 1 (1).png"
      />
      <PortfolioInfo />
      <Footer />
    </>
  );
};

export default Portfolio;